import { Link } from "react-router-dom";
import { GoArrowRight } from "react-icons/go";

import "./ServiceComponentsCSS/ServiceBody.css";

import ServiceList from "../DB/AllServicesList";
import ServiceDetails from "./ServiceDetails";
import { needHelpCallBack } from "../api/api";
import storedServiceList from "../DB/ServiceData";
import { useState } from "react";
import toast from "react-hot-toast";

export default function ServiceBody({ serviceName }) {
  const [payload, setPayload] = useState({
    phone_number: "",
    first_name: "",
    email: "",
    comment: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Call your existing API function
    await fetchNeedHelpCallBack(payload);
  };

  console.log("payload==>", payload);

  // call needhelpcallback api
  const fetchNeedHelpCallBack = async (payload) => {
    try {
      setLoading(true);

      const res = await needHelpCallBack(payload);

      if (res?.data?.status?.toLowerCase() === "success") {
        toast.success(res?.data?.message || "Request submitted successfully!");
        setPayload({
          first_name: "",
          phone_number: "",
          email: "",
          comment: "",
        }); // reset form
      } else {
        console.log("API returned failure:", res?.data);
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Error submitting help request:", err);
      toast.error("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="serviceBody-wrapper">
        <ServiceDetails serviceName={serviceName} />

        {/* <div className="left-sidebar"> */}
          {/* <div className="services-box">
            <h4>Other Services</h4>
            <ul>
              {ServiceList.map((svs, index) => (
                <li key={index}>
                  <Link to={`/service/${svs.path}`}>
                    {svs.name}{" "}
                    <span className="arrow">
                      <GoArrowRight size={18} />
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}

          {/* <div className="consult-box">
            <h4>Book a Consultation:</h4>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="first_name"
                placeholder="Full Name"
                value={payload.first_name}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone_number"
                placeholder="Enter Phone"
                value={payload.phone_number}
                onChange={handleChange}
                required
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
              />
              <input
                type="email"
                name="email"
                placeholder="Enter Email"
                value={payload.email}
                onChange={handleChange}
                required
              />
              <select
                name="comment"
                value={payload.comment}
                onChange={handleChange}
                required
              >
                <option value="">Select Service</option>
                {Object.keys(storedServiceList).map((key, index) => (
                  <option key={index} value={key.toLowerCase()}>
                    {key}
                  </option>
                ))}
              </select>
              <button type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Book Online"}
                
              </button>
            </form>
          </div> */}
        </div>

        {/* <ServiceDetails
                    serviceName = {serviceName}
                /> */}
      {/* </div> */}
    </>
  );
}
